import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { MRATSync } from 'components/MRATSync';
import imageStore from 'utils/ImageDB';
import AlertDialog from 'components/DialogComponent/AlertDialog';
import { handleLogOutFunction } from 'utils/logoutHandler';
import { del } from 'idb-keyval';
import { MRAT_USER_ROLE } from 'journeys/portal/Home/Home.constants';
import { Trim, MatchSRA } from 'helpers/Validation';
import { InformationButton, PaletteButton } from 'elements/CustomHeaderButtons/HeaderButtons';
import { isMobile as isTablet } from 'react-device-detect';
import BackButton from '../../../icons/Arrow - Left';
import EllipsesMenu from 'components/EllipsesMenu/EllipsesMenu';
import { HeaderContainer, GradientLine, HeaderText, TotalRecords, HeaderButton } from './Header.styled';
import UserDropdown from './subSections/UserDropdown/UserDropdown';
import { checkOfflineDataPresent, disableMRATSyncButton, getAllRegionData, setCurrentView, setLateEntryStatus, setPreviousScreen, updateMRATSyncInvalidationStatus } from '../../portal/Home/Home.actions';
import { AdminConstants } from 'journeys/portal/Admin/AdminScreen.constants';
import ColorLedger from './Ledger';
import OfflineAlertDialog from 'journeys/portal/NonMo/OfflineAlertDialog';

const SecondaryHeaderButton = ({ buttonText, handleButton, isDPSDisabled }) => {
    if (buttonText) {
        return (
            <HeaderButton type="button" onClick={handleButton} width={250} disabled={isDPSDisabled}>
                {buttonText}
            </HeaderButton>
        );
    }

    return null;
};
const Header = (props) => {
    const { isMRATOnline, selectedAssetName, userRole, headerText, handleButton, printButtonVisible,
        buttonText, ButtonSection, totalCount, showTotalCount, buttonWidth, buttonHeight, displayUnsavedChangesPopUp,
        headerPrintButtonHandler, closeCameraButtonVisible, testEquipmentSection, dpsSection,
        displayFormStatus, goBack, newImageList, setCurrentAppView, currentAppView, showOfflineFormsCount,
        titleFontSize, formName, selectedTrfId, selectedTag, switchSRAForm, isDPSDisabled, showInfoIcon, colorLegend, setPreviousAppScreen,
        updateInvalidationStatus, checkOfflineFormDataPresent, disableSyncButton, IsLateEntry, setLateEntryUserStatus, bpRegionNameAlias, getAllRegionDataLateEntry, currentView } = props;
    const [logOutAlert, setLogOutAlert] = useState(false);
    const headerLogOutButtonHandler = () => {
        setLogOutAlert(true);
    };
    const handleLogOut = () => {
        setLogOutAlert(false);
        handleLogOutFunction({ updateInvalidationStatus, checkOfflineFormDataPresent, setCurrentAppView, disableSyncButton, setLogOutAlert });
    };
    const [unSavedChangesAlert, setUnSavedChangesAlert] = useState(false);
    const [colorLedgerVisible, setColorLedgerVisible] = useState(false);
    const displayPopUp = MRAT_USER_ROLE.Technician === userRole;
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
    const newTrfId = selectedTrfId ?? Trim(selectedTag.TrfId);
    const printButtonIsVisible = ((currentAppView === 'home' || currentAppView === 'lateEntryHome' || printButtonVisible) && !isTablet && isMRATOnline && (selectedAssetName !== ''));
    const classes = makeStyles({
        button: {
            '&:hover': {
                backgroundColor: 'var(--secondary)',
                borderColor: 'transparent'
            },
            width: buttonWidth ? buttonWidth.toString().concat('px !important') : '105px',
            height: buttonHeight ? buttonHeight.toString().concat('px !important') : '80px'
        }
    })();
    useEffect(() => {
        if (IsLateEntry && currentView === 'lateEntryHome' && bpRegionNameAlias) {
            getAllRegionDataLateEntry();
        }
    }, [bpRegionNameAlias, IsLateEntry]);

    const handleClassicAppClick = () => {
        setLateEntryUserStatus(false);
        setCurrentAppView('home');
        setTimeout(() => {
            getAllRegionDataLateEntry();
        }, 0);
    };
    const headerBackButtonHandler = () => {
        if (MatchSRA(Trim(newTrfId)) && currentAppView === 'P8-1') {
            switchSRAForm();
        } else {
            setUnSavedChangesAlert(true);
        }
    };
    const headerInfoButtonHandler = () => {
        if (currentAppView === 'admin') {
            setCurrentAppView('infoAdmin');
        } else {
            setCurrentAppView('info');
        }
    };
    const headerInfoBackButton = () => {
        if (currentAppView === 'infoAdmin') {
            setCurrentAppView('admin');
        } else {
            isNonMoFeatureEnabled && setPreviousAppScreen('testequipment');
            goBack && setCurrentAppView(goBack);
        }
    };
    const handleUnSavedChanges = () => {
        setUnSavedChangesAlert(false);
        goBack && setCurrentAppView(goBack);
        newImageList.length !== 0 && newImageList.map((item) => del(item, imageStore));
    };

    const handleOnClose = () => {
        setColorLedgerVisible(false);
    };
    let infoBack = null;
    if (!((currentAppView === 'home' || currentAppView === 'lateEntryHome'))) {
        infoBack = showInfoIcon ? (
            <div style={{ marginLeft: '0px' }}>
                <InformationButton
                    buttonHandler={headerInfoButtonHandler}
                    tooltip="Information"
                />
            </div>
        ) : (
            <BackButton
                onClick={() => {
                    (displayUnsavedChangesPopUp || (displayFormStatus && (displayPopUp || (MatchSRA(newTrfId) && currentAppView === 'P8-1'))))
                        ? headerBackButtonHandler()
                        : headerInfoBackButton();
                }}
            />
        );
    }
    const renderMenu = () => {
        if (((formName && !closeCameraButtonVisible) || currentAppView === 'home' || currentAppView === 'lateEntryHome')) {
            return (
                <>
                    <EllipsesMenu
                        testEquipmentSection={testEquipmentSection}
                        dpsSection={dpsSection}
                        printButtonVisible={printButtonIsVisible}
                        headerPrintButtonHandler={headerPrintButtonHandler}
                        setColorLedgerVisible={setColorLedgerVisible}
                        headerLogOutButtonHandler={headerLogOutButtonHandler}
                        isMRATOnline={isMRATOnline}
                        headerInfoButtonHandler={headerInfoButtonHandler}
                        onClassicAppClick={handleClassicAppClick}
                    />
                    {logOutAlert && (
                        <AlertDialog
                            dialogMessage={AdminConstants.DIALOG_MESSAGE}
                            dialogOpenState={logOutAlert}
                            handleClose={() => setLogOutAlert(false)}
                            handleAlertFunction={handleLogOut}
                        />
                    )}
                </>
            );
        }
        return null;
    };
    const renderUserDropdown = () => {
        if (closeCameraButtonVisible || !isMRATOnline || (((formName && !closeCameraButtonVisible) || currentAppView === 'home' || currentAppView === 'lateEntryHome'))) {
            return null;
        }
        return <UserDropdown displayFormStatus={displayFormStatus} />;
    };

    return (
        <div>
            <HeaderContainer titleFontSize={titleFontSize} formName={formName} isDPSDisabled={isDPSDisabled}>
                <img className="cropped" src="/images/bp logo.png" alt="BPLogo" />
                {
                    showTotalCount && (
                        <TotalRecords style={{ fontSize: '11pt' }}>
                            Total Records
                            {' '}
                            {totalCount}
                        </TotalRecords>
                    )
                }
                {
                    showOfflineFormsCount && (
                        <TotalRecords style={{ fontSize: '11pt' }} width="9%">
                            Total Records Saved Offline
                            {' '}
                            {totalCount}
                        </TotalRecords>
                    )
                }
                <HeaderText id="headerText" titleFontSize={titleFontSize}>
                    {headerText}
                </HeaderText>
                <div className="buttonCollection" id="buttonCollection">
                    {isMRATOnline && <MRATSync id="MRATSyncButton" />}
                    {(currentAppView === 'addDpsForm' || currentAppView === 'editDpsForm') && (
                        <div>
                            <PaletteButton buttonHandler={() => setColorLedgerVisible(true)} tooltip="Color Legend" />
                        </div>
                    )}
                    {colorLedgerVisible && <ColorLedger handleOnClose={handleOnClose} colorLegend={colorLegend} isDpsScreen={currentAppView === 'addDpsForm' || currentAppView === 'editDpsForm'} />}
                    {ButtonSection}
                    <SecondaryHeaderButton
                        handleButton={handleButton}
                        buttonText={buttonText}
                        classes={classes}
                        isDPSDisabled={isDPSDisabled}
                    />
                    {!(closeCameraButtonVisible || currentAppView === 'userRoleSelector' || currentAppView === 'error') && infoBack}
                    {renderMenu()}
                    {renderUserDropdown()}
                </div>
            </HeaderContainer>
            <GradientLine />
            {unSavedChangesAlert && (
                <AlertDialog
                    dialogMessage={AdminConstants.DIALOG_MESSAGE}
                    dialogOpenState={unSavedChangesAlert}
                    handleClose={() => setUnSavedChangesAlert(false)}
                    handleAlertFunction={() => handleUnSavedChanges()}
                />
            )}
            {IsLateEntry && !isMRATOnline && <OfflineAlertDialog />}
        </div>
    );
};

const mapStateToProps = ({ AppData, Forms, Home }) => ({
    isMRATOnline: AppData.isMRATOnline,
    newImageList: Forms.newImageList,
    selectedTag: Forms.selectedTag,
    selectedTrfId: Forms.selectedTrfId,
    selectedAssetName: Home.selectedAssetName,
    userRole: Home.userRole,
    currentAppView: Home.currentView,
    IsLateEntry: Home.IsLateEntry,
    bpRegionNameAlias: Home.bpRegionNameAlias,
    currentView: Home.currentView,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    setCurrentAppView: (view) => dispatch(setCurrentView(view)),
    setPreviousAppScreen: (screen) => dispatch(setPreviousScreen(screen)),
    updateInvalidationStatus: (localState) => dispatch(updateMRATSyncInvalidationStatus(localState)),
    checkOfflineFormDataPresent: () => dispatch(checkOfflineDataPresent()),
    disableSyncButton: (status) => dispatch(disableMRATSyncButton(status)),
    setLateEntryUserStatus: (status) => dispatch(setLateEntryStatus(status)),
    getAllRegionDataLateEntry: () => dispatch(getAllRegionData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);

SecondaryHeaderButton.propTypes = {
    buttonText: PropTypes.string,
    handleButton: PropTypes.func,
    isDPSDisabled: PropTypes.bool
};

Header.propTypes = {
    bpRegionNameAlias: PropTypes.string,
    buttonHeight: PropTypes.number,
    ButtonSection: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
        PropTypes.object
    ]),
    buttonText: PropTypes.string,
    buttonWidth: PropTypes.number,
    checkOfflineFormDataPresent: PropTypes.func,
    closeCameraButtonVisible: PropTypes.bool,
    colorLegend: PropTypes.array,
    currentAppView: PropTypes.string,
    currentView: PropTypes.string,
    disableSyncButton: PropTypes.func,
    displayFormStatus: PropTypes.bool,
    displayUnsavedChangesPopUp: PropTypes.bool,
    dpsSection: PropTypes.any,
    formName: PropTypes.string,
    getAllRegionDataLateEntry: PropTypes.func,
    goBack: PropTypes.string,
    handleButton: PropTypes.func,
    headerPrintButtonHandler: PropTypes.func,
    headerText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isDPSDisabled: PropTypes.bool,
    IsLateEntry: PropTypes.bool,
    isMRATOnline: PropTypes.bool.isRequired,
    newImageList: PropTypes.array,
    printButtonVisible: PropTypes.bool,
    selectedAssetName: PropTypes.string,
    selectedTag: PropTypes.object,
    selectedTrfId: PropTypes.string,
    setCurrentAppView: PropTypes.func,
    setLateEntryUserStatus: PropTypes.func,
    setPreviousAppScreen: PropTypes.func,
    showInfoIcon: PropTypes.bool,
    showOfflineFormsCount: PropTypes.bool,
    showTotalCount: PropTypes.bool,
    switchSRAForm: PropTypes.func,
    testEquipmentSection: PropTypes.any,
    titleFontSize: PropTypes.string,
    totalCount: PropTypes.number,
    updateInvalidationStatus: PropTypes.func,
    userRole: PropTypes.string,
};
